// import { useEffect, useMemo, useState } from "react";
// import { Box, Card, Stack, Typography, IconButton, TextField, Button, Divider, CircularProgress, Tooltip } from "@mui/material";
// import { Delete, Edit, Save, Close, Refresh, Add } from "@mui/icons-material";
// import { alpha, styled, useTheme } from "@mui/material/styles";
// import apiService from "Network/apiService";
// import { API_ENDPOINTS } from "Network/apiEndpoints";
// import { useToast } from "OtherReusableFunctionality/ToastContext";
// import { usePageTitle } from "contexts/PageTitleContext";

// const PageContainer = styled(Box)(({ theme }) => ({
//   padding: theme.spacing(2),
// }));

// const HeaderCard = styled(Card)(({ theme }) => ({
//   padding: theme.spacing(2),
//   marginBottom: theme.spacing(2),
//   display: 'flex',
//   alignItems: 'center',
//   justifyContent: 'space-between',
// }));

// const TableCard = styled(Card)(({ theme }) => ({
//   padding: theme.spacing(2),
// }));

// const Row = styled(Box)(({ theme }) => ({
//   display: 'grid',
//   gridTemplateColumns: '64px 1fr 160px 240px',
//   alignItems: 'center',
//   gap: theme.spacing(2),
//   padding: theme.spacing(1.5, 0),
// }));

// const HeaderRow = styled(Row)(({ theme }) => ({
//   color: theme.palette.text.secondary,
//   fontWeight: 600,
// }));

// const Muted = styled(Typography)(({ theme }) => ({
//   color: theme.palette.text.secondary,
// }));

// const ActionWrap = styled(Box)(({ theme }) => ({
//   display: 'flex',
//   alignItems: 'center',
//   gap: theme.spacing(1),
//   justifyContent: 'flex-end',
// }));

// const EventTypesPage = () => {
//   const theme = useTheme();
//   const { showSuccess, showError } = useToast();

//   const [items, setItems] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [savingId, setSavingId] = useState(null);
//   const [deletingId, setDeletingId] = useState(null);
//   const [editing, setEditing] = useState({}); // { [id]: { name: string, sequence: number, isEditingName: boolean } }
//   const [creating, setCreating] = useState(false);
//   const [newEventType, setNewEventType] = useState({ type_name: '', sequence: '' });
//      const { setPageTitle } = usePageTitle();
//   useEffect(() => {
//         setPageTitle('Event Types');
//     }, [setPageTitle]);
//   const userId = useMemo(() => {
//     try {
//       return JSON.parse(localStorage.getItem("logged_data"))?.data?.id || JSON.parse(localStorage.getItem("logged_data"))?.data?.user_id || 1;
//     } catch (_) {
//       return 1;
//     }
//   }, []);

//   const fetchItems = async () => {
//     setLoading(true);
//     try {
//       const res = await apiService.get(`${API_ENDPOINTS.GET_admin_event_type}?user_id=${userId}`);
//       const data = Array.isArray(res?.data) ? res.data : [];
//       setItems(data);
//     } catch (err) {
//       showError(typeof err === 'string' ? err : err?.message || 'Failed to load event types');
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchItems();
//   }, []);

//   const createEventType = async () => {
//     if (!newEventType.type_name || !String(newEventType.type_name).trim()) {
//       showError('Event type name cannot be empty');
//       return;
//     }
//     const seq = Number(newEventType.sequence);
//     if (Number.isNaN(seq)) {
//       showError('Sequence must be a number');
//       return;
//     }

//     setCreating(true);
//     try {
//       const formData = new FormData();
//       formData.append('type_name', String(newEventType.type_name).trim());
//       formData.append('sequence', String(seq));

//       const res = await apiService.post(API_ENDPOINTS.POST_add_event_type, formData, undefined, 'multipart/form-data');
//       showSuccess(res?.message || 'Event type created successfully');
//       setNewEventType({ type_name: '', sequence: '' });
//       await fetchItems();
//     } catch (err) {
//       showError(typeof err === 'string' ? err : err?.message || 'Failed to create event type');
//     } finally {
//       setCreating(false);
//     }
//   };

//   const startEdit = (it) => {
//     setEditing((prev) => ({
//       ...prev,
//       [it.id]: { name: it.type_name, sequence: it.sequence, isEditingName: true },
//     }));
//   };

//   const cancelEdit = (id) => {
//     setEditing((prev) => {
//       const n = { ...prev };
//       delete n[id];
//       return n;
//     });
//   };

//   const saveName = async (id) => {
//     const state = editing[id];
//     if (!state) return;
//     if (!state.name || !String(state.name).trim()) {
//       showError('Type name cannot be empty');
//       return;
//     }
//     setSavingId(id);
//     try {
//       const formData = new FormData();
//       formData.append('event_type_id', String(id));
//       formData.append('type_name', String(state.name).trim());
//       formData.append('user_id', String(userId));

//       const res = await apiService.put(API_ENDPOINTS.UPDATE_event_type, formData, undefined, 'multipart/form-data');
//       showSuccess(res?.message || 'Event type updated');
//       await fetchItems();
//       cancelEdit(id);
//     } catch (err) {
//       showError(typeof err === 'string' ? err : err?.message || 'Failed to update');
//     } finally {
//       setSavingId(null);
//     }
//   };

//   const saveSequence = async (id) => {
//     const state = editing[id] || { sequence: items.find((x) => x.id === id)?.sequence };
//     const seq = Number(state.sequence);
//     if (Number.isNaN(seq)) {
//       showError('Sequence must be a number');
//       return;
//     }
//     setSavingId(id);
//     try {
//       const formData = new FormData();
//       formData.append('event_type_id', String(id));
//       formData.append('sequence', String(seq));
//       formData.append('user_id', String(userId));

//       const res = await apiService.put(API_ENDPOINTS.UPDATE_event_type_sequence, formData, undefined, 'multipart/form-data');
//       showSuccess(res?.message || 'Sequence updated');
//       await fetchItems();
//     } catch (err) {
//       showError(typeof err === 'string' ? err : err?.message || 'Failed to update sequence');
//     } finally {
//       setSavingId(null);
//     }
//   };

//   const removeItem = async (id) => {
//     if (!window.confirm('Delete this event type?')) return;
//     setDeletingId(id);
//     try {
//       const res = await apiService.delete(`${API_ENDPOINTS.DELETE_event_type}?user_id=${userId}&event_type_id=${id}`);
//       showSuccess(res?.message || 'Event type deleted');
//       await fetchItems();
//     } catch (err) {
//       showError(typeof err === 'string' ? err : err?.message || 'Failed to delete');
//     } finally {
//       setDeletingId(null);
//     }
//   };

//   return (
//     <PageContainer>
//       <HeaderCard>
//         <Box>
//           <Typography variant="h6" fontWeight={700}>Event Types</Typography>
//           <Muted variant="body2">View, rename, resequence, and delete event types</Muted>
//         </Box>
//         <Box sx={{ display: 'flex', gap: 2 }}>
//           <Button startIcon={<Refresh />} variant="outlined" onClick={fetchItems} disabled={loading}>
//             {loading ? 'Refreshing...' : 'Refresh'}
//           </Button>
//         </Box>
//       </HeaderCard>

//       {/* Add Event Type Form */}
//       <TableCard sx={{ mb: 2 }}>
//         <Typography variant="subtitle1" fontWeight={600} sx={{ mb: 2 }}>Add New Event Type</Typography>
//         <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flexWrap: 'wrap' }}>
//           <TextField
//             label="Event Type Name"
//             size="small"
//             value={newEventType.type_name}
//             onChange={(e) => setNewEventType(prev => ({ ...prev, type_name: e.target.value }))}
//             sx={{ minWidth: 200 }}
//           />
//           <TextField
//             label="Sequence"
//             size="small"
//             type="number"
//             value={newEventType.sequence}
//             onChange={(e) => setNewEventType(prev => ({ ...prev, sequence: e.target.value }))}
//             sx={{ width: 120 }}
//           />
//           <Button 
//             variant="contained" 
//             onClick={createEventType} 
//             disabled={creating || !newEventType.type_name.trim() || !newEventType.sequence}
//             startIcon={creating ? <CircularProgress size={16} /> : <Add />}
//           >
//             {creating ? 'Creating...' : 'Create'}
//           </Button>
//         </Box>
//       </TableCard>

//       <TableCard>
//         <HeaderRow>
//           <Muted variant="caption">Sr No</Muted>
//           <Muted variant="caption">Type Name</Muted>
//           <Muted variant="caption">Sequence</Muted>
//           <Muted variant="caption" sx={{ textAlign: 'right' }}>Actions</Muted>
//         </HeaderRow>
//         <Divider />

//         {loading ? (
//           <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', py: 6 }}>
//             <CircularProgress size={28} />
//           </Box>
//         ) : items.length === 0 ? (
//           <Box sx={{ textAlign: 'center', py: 6 }}>
//             <Muted>No event types found.</Muted>
//           </Box>
//         ) : (
//           items.map((it, index) => {
//             const isEditing = !!editing[it.id];
//             return (
//               <Box key={it.id}>
//                 <Row>
//                   <Typography variant="body2">{index + 1}</Typography>

//                   {isEditing ? (
//                     <TextField
//                       size="small"
//                       fullWidth
//                       value={editing[it.id]?.name ?? ''}
//                       onChange={(e) => setEditing((prev) => ({ ...prev, [it.id]: { ...prev[it.id], name: e.target.value } }))}
//                     />
//                   ) : (
//                     <Typography variant="body1" fontWeight={600}>{it.type_name}</Typography>
//                   )}

//                   <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                     <TextField
//                       size="small"
//                       type="number"
//                       sx={{ width: 100 }}
//                       value={(editing[it.id]?.sequence ?? it.sequence)}
//                       onChange={(e) => setEditing((prev) => ({ ...prev, [it.id]: { ...prev[it.id], sequence: e.target.value } }))}
//                     />
//                     <Button size="small" variant="contained" onClick={() => saveSequence(it.id)} disabled={savingId === it.id}>
//                       {savingId === it.id ? 'Saving...' : 'Update'}
//                     </Button>
//                   </Box>

//                   <ActionWrap>
//                     {isEditing ? (
//                       <>
//                         <Tooltip title="Save name">
//                           <span>
//                             <IconButton color="success" onClick={() => saveName(it.id)} disabled={savingId === it.id}>
//                               <Save />
//                             </IconButton>
//                           </span>
//                         </Tooltip>
//                         <Tooltip title="Cancel">
//                           <IconButton color="inherit" onClick={() => cancelEdit(it.id)}>
//                             <Close />
//                           </IconButton>
//                         </Tooltip>
//                       </>
//                     ) : (
//                       <Tooltip title="Rename">
//                         <IconButton color="primary" onClick={() => startEdit(it)}>
//                           <Edit />
//                         </IconButton>
//                       </Tooltip>
//                     )}

//                     <Tooltip title="Delete">
//                       <span>
//                         <IconButton color="error" onClick={() => removeItem(it.id)} disabled={deletingId === it.id}>
//                           {deletingId === it.id ? <CircularProgress size={18} /> : <Delete />}
//                         </IconButton>
//                       </span>
//                     </Tooltip>
//                   </ActionWrap>
//                 </Row>
//                 <Divider />
//               </Box>
//             );
//           })
//         )}
//       </TableCard>
//     </PageContainer>
//   );
// };

// export default EventTypesPage; 


import { useEffect, useMemo, useState } from "react";
import { Box, Card, Typography, IconButton, TextField, Button, Divider, CircularProgress, Tooltip } from "@mui/material";
import { Delete, Edit, Save, Close, Refresh, Add } from "@mui/icons-material";
import { styled, useTheme } from "@mui/material/styles";
import apiService from "Network/apiService";
import { API_ENDPOINTS } from "Network/apiEndpoints";
import { useToast } from "OtherReusableFunctionality/ToastContext";
import { usePageTitle } from "contexts/PageTitleContext";
import { useDeleteConfirmation } from "contexts/DeleteConfirmationContext";
import {
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  Chip,
} from "@mui/material";
// ─── CHANGE 1: Import buttonConfig ─────────────────────────────────────────────
import buttonConfig from "config/ConfigAccessButton";
// ───────────────────────────────────────────────────────────────────────────────

const PageContainer = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2),
}));

const HeaderCard = styled(Card)(({ theme }) => ({
  padding: theme.spacing(2),
  marginBottom: theme.spacing(2),
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
}));

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  fontSize: "0.875rem",
  padding: "12px 16px",
  "&.header": {
    fontWeight: 600,
    backgroundColor: theme.palette.grey[100],
  }
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(even)": {
    backgroundColor: theme.palette.action.hover,
  },
  "&:hover": {
    backgroundColor: theme.palette.action.hover,
  }
}));

const TableCard = styled(Card)(({ theme }) => ({
  padding: theme.spacing(2),
}));

const Row = styled(Box)(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "64px 1fr 160px 240px",
  alignItems: "center",
  gap: theme.spacing(2),
  padding: theme.spacing(1.5, 0),
}));

const HeaderRow = styled(Row)(({ theme }) => ({
  color: theme.palette.text.secondary,
  fontWeight: 600,
}));

const Muted = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
}));

const ActionWrap = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(1),
  justifyContent: "flex-end",
}));

const EventTypesPage = () => {
  const theme = useTheme();
  const { showSuccess, showError } = useToast();
  const { setPageTitle } = usePageTitle();
  const { showDeleteConfirmation } = useDeleteConfirmation();

  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [savingId, setSavingId] = useState(null);
  const [deletingId, setDeletingId] = useState(null);
  const [editing, setEditing] = useState({});
  const [creating, setCreating] = useState(false);
  const [newEventType, setNewEventType] = useState({ type_name: "", sequence: "" });

  useEffect(() => {
    setPageTitle("Event Types");
  }, [setPageTitle]);

  // ─── CHANGE 2: Setup permissions from config ─────────────────────────────────
  const eventConfig = buttonConfig["Event Types"] || {};
  const can = (action) => !!eventConfig[action];
  // ─────────────────────────────────────────────────────────────────────────────

  const userId = useMemo(() => {
    try {
      return (
        JSON.parse(localStorage.getItem("logged_data"))?.data?.id ||
        JSON.parse(localStorage.getItem("logged_data"))?.data?.user_id ||
        1
      );
    } catch (_) {
      return 1;
    }
  }, []);

  const fetchItems = async () => {
    setLoading(true);
    try {
      const res = await apiService.get(`${API_ENDPOINTS.GET_admin_event_type}?user_id=${userId}`);
      const data = Array.isArray(res?.data) ? res.data : [];

      // ✅ ALWAYS SORT BY SEQUENCE
      const sortedData = [...data].sort(
        (a, b) => Number(a.sequence || 0) - Number(b.sequence || 0)
      );

      setItems(sortedData);
    } catch (err) {
      if (!navigator.onLine) {
        showError("No network connection - offline mode active");
      } else {
        showError(typeof err === "string" ? err : err?.message || "Failed to update sequence");
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchItems();
  }, []);

  const createEventType = async () => {
    if (!newEventType.type_name || !String(newEventType.type_name).trim()) {
      showError("Event type name cannot be empty");
      return;
    }
    const seq = Number(newEventType.sequence);
    if (Number.isNaN(seq)) {
      showError("Sequence must be a number");
      return;
    }

    setCreating(true);
    try {
      const formData = new FormData();
      formData.append("type_name", String(newEventType.type_name).trim());
      formData.append("sequence", String(seq));

      const res = await apiService.post(API_ENDPOINTS.POST_add_event_type, formData, undefined, "multipart/form-data");
      showSuccess(res?.message || "Event type created successfully");
      setNewEventType({ type_name: "", sequence: "" });
      await fetchItems();
    } catch (err) {
      showError(typeof err === "string" ? err : err?.message || "Failed to create event type");
    } finally {
      setCreating(false);
    }
  };

  const startEdit = (it) => {
    setEditing((prev) => ({
      ...prev,
      [it.id]: { name: it.type_name, sequence: it.sequence, isEditingName: true },
    }));
  };

  const cancelEdit = (id) => {
    setEditing((prev) => {
      const n = { ...prev };
      delete n[id];
      return n;
    });
  };

  const saveName = async (id) => {
    const state = editing[id];
    if (!state) return;
    if (!state.name || !String(state.name).trim()) {
      showError("Type name cannot be empty");
      return;
    }

    const seq = Number(state.sequence);
    if (Number.isNaN(seq)) {
      showError("Sequence must be a number");
      return;
    }

    setSavingId(id);
    try {
      // Update name
      const formData = new FormData();
      formData.append("event_type_id", String(id));
      formData.append("type_name", String(state.name).trim());
      formData.append("user_id", String(userId));

      const res = await apiService.put(API_ENDPOINTS.UPDATE_event_type, formData, undefined, "multipart/form-data");

      // Update sequence if changed
      const originalItem = items.find((x) => x.id === id);
      if (!Number.isNaN(seq) && originalItem && seq !== originalItem.sequence) {
        const seqFormData = new FormData();
        seqFormData.append("event_type_id", String(id));
        seqFormData.append("sequence", String(seq));
        seqFormData.append("user_id", String(userId));
        await apiService.put(API_ENDPOINTS.UPDATE_event_type_sequence, seqFormData, undefined, "multipart/form-data");
      }

      showSuccess(res?.message || "Event type updated");
      await fetchItems();
      cancelEdit(id);
    } catch (err) {
      showError(typeof err === "string" ? err : err?.message || "Failed to update");
    } finally {
      setSavingId(null);
    }
  };

  const saveSequence = async (id) => {
    const state = editing[id] || { sequence: items.find((x) => x.id === id)?.sequence };
    const seq = Number(state.sequence);
    if (Number.isNaN(seq)) {
      showError("Sequence must be a number");
      return;
    }
    setSavingId(id);
    try {
      const formData = new FormData();
      formData.append("event_type_id", String(id));
      formData.append("sequence", String(seq));
      formData.append("user_id", String(userId));

      const res = await apiService.put(API_ENDPOINTS.UPDATE_event_type_sequence, formData, undefined, "multipart/form-data");
      showSuccess(res?.message || "Sequence updated");
      await fetchItems();
    } catch (err) {
      showError(typeof err === "string" ? err : err?.message || "Failed to update sequence");
    } finally {
      setSavingId(null);
    }
  };

  const removeItem = async (id) => {
    const confirmed = await showDeleteConfirmation({
      title: "Delete Event Type",
      message: "Are you sure you want to delete this event type?",
      confirmButtonText: "Delete",
      cancelButtonText: "Cancel"
    });
    
    if (!confirmed) return;
    setDeletingId(id);
    try {
      const res = await apiService.delete(`${API_ENDPOINTS.DELETE_event_type}?user_id=${userId}&event_type_id=${id}`);
      showSuccess(res?.message || "Event type deleted");
      await fetchItems();
    } catch (err) {
      showError(typeof err === "string" ? err : err?.message || "Failed to delete");
    } finally {
      setDeletingId(null);
    }
  };

  return (
    <PageContainer>
      {/* <HeaderCard>
        { <Box>
          <Typography variant="h6" fontWeight={700}>
            Event Types
          </Typography>
          <Muted variant="body2">View, rename, resequence, and delete event types </Muted>
        </Box> }
        <Box />
      </HeaderCard> */}

      {/* Add Event Type Form */}
      <TableCard sx={{ mb: 2 }}>
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 2, mb: 2 }}>
          <Typography variant="subtitle1" fontWeight={600}>
            Add New Event Type
          </Typography>
          <Button startIcon={<Refresh />} variant="contained" onClick={fetchItems} disabled={loading}>
            {loading ? "Refreshing..." : "Refresh"}
          </Button>
        </Box>
        <Box sx={{ display: "flex", alignItems: "center", gap: 2, flexWrap: "wrap" }}>
          <TextField
            label="Event Type Name"
            size="small"
            value={newEventType.type_name}
            onChange={(e) => setNewEventType((prev) => ({ ...prev, type_name: e.target.value }))}
            sx={{ minWidth: 200 }}
          />
          <TextField
            label="Sequence"
            size="small"
            type="number"
            value={newEventType.sequence}
            onChange={(e) => setNewEventType((prev) => ({ ...prev, sequence: e.target.value }))}
            sx={{ width: 120 }}
          />
          {/* ─── CHANGE 3: Create button — disabled when no update permission ─────── */}
          <Button
            variant="contained"
            onClick={() => can('create_event') && createEventType()}
            disabled={creating || !newEventType.type_name.trim() || !newEventType.sequence || !can('create_event')}
            startIcon={creating ? <CircularProgress size={16} /> : <Add />}
          >
            {creating ? "Creating..." : "Create"}
          </Button>
          {/* ─────────────────────────────────────────────────────────────────────── */}
        </Box>
      </TableCard>

      <TableCard sx={{ mb: 2 }}>
        <Box sx={{ width: "100%", p: 2 }}>
          <TableContainer component={Paper} sx={{ borderRadius: 2, overflow: "hidden" }}>
            <Table>
              {/* ---------- TABLE HEADER ---------- */}
              <TableHead>
                <TableRow >
                  <StyledTableCell className="header"  style={{padding:"16px",backgroundColor: theme.palette.grey[200],}}>Sr No</StyledTableCell>
                  <StyledTableCell className="header" style={{backgroundColor: theme.palette.grey[200],}}>
                    <Box sx={{ width: 160, textAlign: "center" }}>
                      Type Name
                    </Box>
                  </StyledTableCell>
                  <StyledTableCell className="header" style={{backgroundColor: theme.palette.grey[200],}}>
                    <Box sx={{ width: 180, textAlign: "center" }}>
                      Sequence
                    </Box>
                  </StyledTableCell>
                  <StyledTableCell className="header" style={{backgroundColor: theme.palette.grey[200],}}>
                    <Box sx={{ width: 88, textAlign: "center" }}>
                      Actions
                    </Box>
                  </StyledTableCell>
                </TableRow>
              </TableHead>

              {/* ---------- TABLE BODY ---------- */}
              <TableBody>
                {loading ? (
                  <TableRow>
                    <TableCell colSpan={4} align="center" sx={{ py: 5 }}>
                      <CircularProgress size={28} />
                    </TableCell>
                  </TableRow>
                ) : items.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={4} align="center" sx={{ py: 4 }}>
                      <Typography variant="body2" color="text.secondary">
                        No event types found.
                      </Typography>
                    </TableCell>
                  </TableRow>
                ) : (
                  [...items]
                    .sort((a, b) => Number(a.sequence || 0) - Number(b.sequence || 0))
                    .map((it, index) => {
                      const isEditing = !!editing[it.id];

                      return (
                        <StyledTableRow key={it.id}>
                          {/* ---------- SR NO ---------- */}
                          <StyledTableCell style={{padding:"16px"}}>
                            <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 500 }}>
                              {index + 1}
                            </Typography>
                          </StyledTableCell>

                          {/* ---------- TYPE NAME ---------- */}
                          <StyledTableCell >
                            {isEditing ? (
                              <TextField
                                size="small"
                                fullWidth
                                value={editing[it.id]?.name ?? it.type_name}
                                onChange={(e) =>
                                  setEditing((prev) => ({
                                    ...prev,
                                    [it.id]: { ...prev[it.id], name: e.target.value },
                                  }))
                                }
                              />
                            ) : (
                              <Typography variant="subtitle2" fontWeight={600}>
                                {it.type_name}
                              </Typography>
                            )}
                          </StyledTableCell>

                          {/* ---------- SEQUENCE ---------- */}
                          <StyledTableCell>
                            <Box display="flex" alignItems="center" gap={1}>
                              <TextField
                                size="small"
                                type="number"
                                sx={{ width: 100 }}
                                value={
                                  isEditing
                                    ? editing[it.id]?.sequence ?? it.sequence
                                    : it.sequence
                                }
                                disabled={savingId === it.id}
                                onChange={(e) =>
                                  setEditing((prev) => ({
                                    ...prev,
                                    [it.id]: {
                                      name: prev[it.id]?.name ?? it.type_name,
                                      sequence: e.target.value,
                                    },
                                  }))
                                }
                              />

                              {!isEditing && (
                                /* ─── CHANGE 4: Update sequence button — disabled when no update permission ─ */
                                <Button
                                  size="small"
                                  variant="contained"
                                  onClick={() => can('update') && saveSequence(it.id)}
                                  disabled={savingId === it.id || !can('update')}
                                >
                                  {savingId === it.id ? "Saving..." : "Update"}
                                </Button>
                                /* ─────────────────────────────────────────────────────────────────────── */
                              )}
                            </Box>
                          </StyledTableCell>

                          {/* ---------- ACTIONS ---------- */}
                          <StyledTableCell >
                            <Box display="flex"  gap={1}>
                              {isEditing ? (
                                <>
                                  {/* ─── CHANGE 5: Save button — disabled when no edit permission ────────── */}
                                  <Tooltip title={can('edit') ? "Save" : "No permission to edit"}>
                                    <span>
                                      <IconButton
                                        color="success"
                                        onClick={() => can('edit') && saveName(it.id)}
                                        disabled={savingId === it.id || !can('edit')}
                                      >
                                        <Save />
                                      </IconButton>
                                    </span>
                                  </Tooltip>
                                  {/* ─────────────────────────────────────────────────────────────────────── */}

                                  <Tooltip title="Cancel">
                                    <IconButton color="inherit" onClick={() => cancelEdit(it.id)}>
                                      <Close />
                                    </IconButton>
                                  </Tooltip>
                                </>
                              ) : (
                                /* ─── CHANGE 6: Edit button — disabled when no edit permission ────────── */
                                <Tooltip title={can('edit') ? "Edit" : "No permission to edit"}>
                                  <span>
                                    <IconButton 
                                      color="editGreen" 
                                      onClick={() => can('edit') && startEdit(it)}
                                      disabled={!can('edit')}
                                    >
                                      <Edit />
                                    </IconButton>
                                  </span>
                                </Tooltip>
                                /* ─────────────────────────────────────────────────────────────────────── */
                              )}

                              {/* ─── CHANGE 7: Delete button — disabled when no delete permission ────── */}
                              <Tooltip title={can('delete') ? "Delete" : "No permission to delete"}>
                                <span>
                                  <IconButton
                                    color="error"
                                    onClick={() => can('delete') && removeItem(it.id)}
                                    disabled={deletingId === it.id || !can('delete')}
                                  >
                                    {deletingId === it.id ? (
                                      <CircularProgress size={18} />
                                    ) : (
                                      <Delete />
                                    )}
                                  </IconButton>
                                </span>
                              </Tooltip>
                              {/* ─────────────────────────────────────────────────────────────────────── */}
                            </Box>
                          </StyledTableCell>
                        </StyledTableRow>
                      );
                    })
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </TableCard>
    </PageContainer>
  );
};

export default EventTypesPage;